import { render, staticRenderFns } from "./employeeRegistration.vue?vue&type=template&id=34561d26&scoped=true&"
import script from "./employeeRegistration.vue?vue&type=script&lang=js&"
export * from "./employeeRegistration.vue?vue&type=script&lang=js&"
import style0 from "./employeeRegistration.vue?vue&type=style&index=0&id=34561d26&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34561d26",
  null
  
)

export default component.exports